import qs from "querystring";

// ==================== API环境配置 ====================
// 根据项目需求选择对应的API环境地址

// 盈养项目API地址
// const origin = 'https://v1.api.nb-s.cn';           // 盈养正式环境
// const origin = 'https://apitest.nb-s.cn';          // 盈养测试环境

// 海王项目API地址
const origin = "https://apitest.nb-s.cn"; // 海王测试环境
// const origin = 'https://v1.api.nb-s.cn';              // 海王正式环境

// 流式数据API地址 (用于AI功能的流式数据处理)
const Testorigin = "https://apitest.nb-s.cn"; // 流式数据测试环境

// 导出测试环境基础URL
export { Testorigin };

export function post(url, params) {
  return fetch(origin + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    // body: qs.encode(params)
    body: JSON.stringify(params),
  })
    .then((res) => res.json())
    .then((res) => res.data);
}

export function get(url, params) {
  const queryString = params ? `?${qs.encode(params)}` : "";
  return fetch(origin + url + queryString, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((res) => res.data);
}

export function getStream(url, params) {
  const queryString = params ? `?${qs.encode(params)}` : "";
  return fetch(origin + url + queryString, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => res);
}
export function postStream(url, formData) {
  return fetch(origin + url, {
    method: "POST",
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    body: formData,
  }).then((res) => res);
}
export async function getStreamText(url, params, abortController, queue) {
  const queryString = `?serial_number=${params.serial_number}`;
  const fullUrl = Testorigin + url + queryString;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    signal: abortController?.signal,
  };

  try {
    const response = await fetch(fullUrl, options);
    if (!response.ok) throw new Error(`请求失败，状态码: ${response.status}`);

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    let done = false;

    while (!done) {
      const { value, done: streamDone } = await reader.read();
      done = streamDone;

      if (value) {
        buffer += decoder.decode(value, { stream: true });
        let lines = buffer.split("\n");
        buffer = lines.pop() || "";

        for (const line of lines) {
          const trimmed = line.trim();
          if (!trimmed.startsWith("data:")) continue;
          const jsonStr = trimmed.slice(5).trim();
          try {
            const parsed = JSON.parse(jsonStr);
            queue.push(parsed); // 生产者放入队列
          } catch (e) {
            console.warn("解析数据出错:", e, "原始数据:", jsonStr);
            // 解析失败，保留到下次继续拼接
            buffer = "data:" + jsonStr;
          }
        }
      }
    }

    // 处理最后可能的数据
    if (buffer.trim()) {
      const trimmed = buffer.trim();
      if (trimmed.startsWith("data:")) {
        const jsonStr = trimmed.slice(5).trim();
        try {
          const parsed = JSON.parse(jsonStr);
          queue.push(parsed);
        } catch (e) {
          console.warn("解析最终数据出错:", e);
        }
      }
    }

    queue.close(); // 关闭队列表示数据结束
  } catch (error) {
    console.error("获取流式数据时出错:", error);
    if (queue) {
      // 如果是主动中断请求，不标记为错误
      if (error.name === "AbortError") {
        console.log("请求被用户取消");
        queue.close(); // 正常关闭队列
      } else {
        queue.setError(error); // 设置错误状态
      }
    }
    throw error;
  }
}

export async function postFormDataStream(
  url,
  formData,
  abortController,
  queue
) {
  const fullUrl = Testorigin + url;
  const options = {
    method: "POST",
    body: formData,
    signal: abortController?.signal,
  };

  try {
    const response = await fetch(fullUrl, options);
    if (!response.ok) throw new Error(`请求失败，状态码: ${response.status}`);

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    let done = false;

    while (!done) {
      const { value, done: streamDone } = await reader.read();
      done = streamDone;

      if (value) {
        buffer += decoder.decode(value, { stream: true });
        let lines = buffer.split("\n");
        buffer = lines.pop() || "";

        for (const line of lines) {
          const trimmed = line.trim();
          if (!trimmed.startsWith("data:")) continue;
          const jsonStr = trimmed.slice(5).trim();
          try {
            const parsed = JSON.parse(jsonStr);
            queue.push(parsed); // 生产者放入队列
          } catch (e) {
            console.warn("解析数据出错:", e, "原始数据:", jsonStr);
            // 解析失败，保留到下次继续拼接
            buffer = "data:" + jsonStr;
          }
        }
      }
    }

    // 处理最后可能的数据
    if (buffer.trim()) {
      const trimmed = buffer.trim();
      if (trimmed.startsWith("data:")) {
        const jsonStr = trimmed.slice(5).trim();
        try {
          const parsed = JSON.parse(jsonStr);
          queue.push(parsed);
        } catch (e) {
          console.warn("解析最终数据出错:", e);
        }
      }
    }

    queue.close(); // 关闭队列表示数据结束
  } catch (error) {
    console.error("发送表单数据流时出错:", error);
    if (queue) {
      // 如果是主动中断请求，不标记为错误
      if (error.name === "AbortError") {
        console.log("请求被用户取消");
        queue.close(); // 正常关闭队列
      } else {
        queue.setError(error); // 设置错误状态
      }
    }
    throw error;
  }
}
